import { useState } from 'react';
import type { DokumentyDokumentDto, KosPolozkaKosDto } from '@gov-nx/api';
import type { Nullable } from '@gov-nx/core/types';

export const useMyFilesModals = () => {
	const [fileForActionModal, setFileForActionModal] =
		useState<Nullable<DokumentyDokumentDto>>(null);

	const [binnedFileForActionModal, setBinnedFileForActionModal] =
		useState<Nullable<KosPolozkaKosDto>>(null);

	const [noFileModal, setNoFileModal] =
		useState<Nullable<DokumentyDokumentDto>>(null);

	const closeActiveModal = () =>
		fileForActionModal
			? setFileForActionModal(null)
			: setBinnedFileForActionModal(null);

	return {
		fileForActionModal,
		setFileForActionModal,
		binnedFileForActionModal,
		setBinnedFileForActionModal,
		noFileModal,
		setNoFileModal,
		closeActiveModal,
	};
};
